import { IDataGetUserInfo } from 'types';
import { TUserInfoVisibleForm } from './userProfileContext';

export enum UserProfileActionTypes {
	SET_USER_FOR_USER_INFO = 'SET_USER_FOR_USER_INFO',
	CHANGE_USER_INFO_VISIBLE_FORM = 'CHANGE_USER_INFO_VISIBLE_FORM',
}

interface ISetUserForUserInfo {
	type: UserProfileActionTypes.SET_USER_FOR_USER_INFO;
	payload: {
		userForUserInfo: IDataGetUserInfo;
	};
}

interface IChangeUserInfoVisibleForm {
	type: UserProfileActionTypes.CHANGE_USER_INFO_VISIBLE_FORM;
	payload: {
		userInfoVisibleForm: TUserInfoVisibleForm;
	};
}

export type TUserProfileAction = ISetUserForUserInfo | IChangeUserInfoVisibleForm;
